import React, {Component} from 'react';
import './App.css';
import Cam from "./components/Cam/cam";
import turn_symbol from './images/symborl_turn.svg';

import pause from './images/pause.svg';
import play from './images/play.svg';

const jsQR = require("jsqr");

class Language extends Component {
    constructor(props) {
        super(props);
        this.languages = {
            0: ['de', 'Deutsch'],
            1: ['en', 'English'],
            2: ['fr', 'Francais'],
        }
    }

    render() {
        return (
            <div className={'holder_languages'}>
                {
                    Object.keys(this.languages).map(
                        (el, i) =>
                            <div
                                onClick={(i) => this.props.set_language(this.languages[el][0])}
                                key={i}
                                className={
                                    `${this.languages[el][0] === this.props.lang ? 'active' : ''} button_simple`
                                }
                            >
                                {`${this.languages[el][1]}`}
                            </div>
                    )
                }
            </div>
        )
    }
}

class Player extends Component {
    constructor(props) {
        super();
        this.interval = null
        this.old_state = undefined

        this.state = {
            audio: null,
            perc: 0,
            playing: true,
            pressed: false,
        }
    }

    set_playhead = () => {
        this.setState({perc: this.state.audio.currentTime / this.state.audio.duration})
    }

    set_playing = () => {
        if (this.state.audio.paused) {
            this.state.audio.play()
        } else {
            this.state.audio.pause()
        }
        this.setState({playing: !this.state.playing})
    }

    componentDidMount() {
        this.setState({audio: document.querySelector('audio')})
        this.interval = setInterval(this.set_playhead, 10)
    }

    componentWillUnmount() {
        clearInterval(this.interval)
    }

    handle_touch = (ev) => {
        ev.stopPropagation()
        switch (ev.type) {
            case 'touchstart':
                this.old_state = !this.state.audio.paused
                this.setState({pressed: true})
                this.state.audio.pause()
                break
            case 'touchmove':
                if (this.state.pressed) {
                    const bb = document.querySelector('.Player .track').getBoundingClientRect()
                    const perc = Math.min(Math.max((ev.touches[0].clientX - bb.left) / bb.width, 0), 1)
                    this.state.audio.currentTime = this.state.audio.duration * perc
                }
                break
            case 'touchend':
                if (this.old_state) {
                    this.state.audio.play()
                }
                this.setState({pressed: false})
                break
            default:
                break
        }
    }

    render() {
        return (
            <div className={'Player'} style={{zIndex: 10}}>
                <div
                    className={'action_player'} onClick={this.set_playing}
                    style={{backgroundImage: !this.state.playing ? `url(${play})` : `url(${pause})`}}
                />
                <div
                    className={'trackholder'}
                    onTouchStart={this.handle_touch}
                    onTouchMove={this.handle_touch}
                    onTouchEnd={this.handle_touch}
                >
                    <div className={'track'}>
                        {
                            this.state.audio &&
                            <div
                                className={'bubble'}
                                style={{marginLeft: `${this.state.perc * 100}%`}}
                            />
                        }
                    </div>
                </div>
            </div>
        )
    }
}

class Instruction extends Component {
    render() {
        return (
            <div
                className={'instructions_yellow'}
                onClick={() => this.props.action()}
            >
                <div className={'inner_instructions'}
                     dangerouslySetInnerHTML={{__html: this.props.instruction || '&nbsp;'}}></div>
                {
                    (this.props.level > 3 && this.props.level % 2 === 0) &&
                    <Player/>
                }
            </div>
        )
    }
}

class Footer extends Component {
    render() {
        return (
            <div
                className={'footer instructions_yellow'}
                style={this.props.qr ? {position: 'fixed', zIndex: 1001, bottom: 0} : {}}
            >
                {
                    this.props.level > 3 && this.props.level <= 200 &&
                    <div className={'icon_0 shadow'} onClick={() => this.props.center_map()}/>
                }
                {/*<div className={'icon_1 shadow'} onClick={() => this.props.set_cam()}/>*/}
                {/*<div className={'icon_2 shadow'} onClick={() => this.props.go_back()}/>*/}
            </div>
        )
    }
}

class MyMap extends Component {
    constructor(props) {
        super(props);

        this.directionsService = null
        this.directionsRenderer = null

        this.interval = null;
        this.geo_interval = null;

        this.coordinates = [
            {
                num: 1,
                lat: 50.7369116,
                lng: 7.1008258
            },
            {
                num: 2,
                lat: 50.7363088,
                lng: 7.1014159
            },
            {
                num: 3,
                lat: 50.735105,
                lng: 7.1016548
            },
            {
                num: 4,
                lat: 50.734660,
                lng: 7.101237
            },
            {
                num: 5,
                lat: 50.7337841,
                lng: 7.1010197
            },
            {
                num: 6,
                lat: 50.734273,
                lng: 7.1051029
            },
            {
                num: 7,
                lat: 50.733917,
                lng: 7.100242
            },
            {
                num: 8,
                lat: 50.733804,
                lng: 7.099671
            },
            {
                num: 9,
                lat: 50.736055,
                lng: 7.093238
            }
        ];

        this.map_style = [
            {
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#212121"
                    }
                ]
            },
            {
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#757575"
                    }
                ]
            },
            {
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#212121"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#757575"
                    }
                ]
            },
            {
                "featureType": "administrative.country",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            },
            {
                "featureType": "administrative.land_parcel",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "administrative.locality",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#bdbdbd"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#757575"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#181818"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#616161"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#1b1b1b"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#2c2c2c"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#8a8a8a"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#373737"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#3c3c3c"
                    }
                ]
            },
            {
                "featureType": "road.highway.controlled_access",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#4e4e4e"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#616161"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#757575"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#000000"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#3d3d3d"
                    }
                ]
            }
        ];

        this.my_map = null;

        this.own_postion_marker = null;
        this.own_postion = null;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        console.log(2345)
        if (prevProps.currentChoice !== this.props.currentChoice || (prevProps.level !== this.props.level && this.props.currentChoice)) {
            console.log(this.props.currentChoice)
            let found = this.coordinates.filter(
                el => el.num === this.props.currentChoice + 1
            )
            if (found.length > 0) {
                found = found[0]

                var request = {
                    origin: this.own_postion,
                    destination: found,
                    travelMode: 'WALKING'
                };
                console.log(request)
                this.directionsService.route(
                    request,
                    (result, status) => {
                        console.log(result, status)
                        if (status === 'OK') {
                            this.directionsRenderer.setDirections(result);

                            // var marker = new this.google.maps.Marker({
                            //     position: target,
                            //     label: "9",
                            //     map: this.map
                            // });
                        }
                    }
                )

                console.log('Set navi to:', found)
            } else {
                console.log('Clear navi.')
            }
        }
    }

    componentDidMount() {
        console.log('---')
        this.interval = setInterval(this.add_map, 10);
        this.add_map();
        this.geo_interval = setInterval(this.set_position, 100)
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        clearInterval(this.geo_interval)
    }

    center_card = () => {

        if (navigator.geolocation) {
            this.my_map.setCenter(this.own_postion);
        }
    };

    set_position = () => {
        if (this.my_map && navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                this.own_postion = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };

                this.own_postion_marker.setPosition(this.own_postion);

            }, () => true);
        } else if (!navigator.geolocation) {
            clearInterval(this.geo_interval)
        }
    };

    add_map = () => {
        if (window.google) {
            this.directionsService = new window.google.maps.DirectionsService();
            this.directionsRenderer = new window.google.maps.DirectionsRenderer({suppressMarkers: true});

            clearInterval(this.interval);
            const center = {lat: 50.735622, lng: 7.099};
            const map = document.getElementById('map');
            const my_map = new window.google.maps.Map(
                map,
                {
                    zoom: 15,
                    center: center,
                    styles: this.map_style,
                    disableDefaultUI: true
                }
            );

            this.directionsRenderer.setMap(my_map)

            this.my_map = my_map;

            for (let i = 0; i < this.coordinates.length; i++) {
                const my_marker = new window.google.maps.Marker(
                    {
                        position: this.coordinates[i],
                        icon: this.props.spots[i],
                        map: my_map
                    }
                );
                my_marker.addListener('click', () => this.props.choice(i))
            }


            if (navigator.geolocation) {
                this.own_postion_marker = new window.google.maps.Marker({map: my_map});
            }
        }
    };

    render() {
        return (
            <div id={'map'}>
            </div>
        )
    }
}

class App extends Component {
    constructor(props) {
        super(props);

        this.check_interval = null;
        this.audio = null;

        this.images = [];
        let i = 0;
        while (true) {
            try {
                this.images.push(require(`./bg_images/${i * 2 + 6}.jpg`));
            } catch (err) {
                break
            }
            i += 1
        }

        this.audio_files = [];
        i = 0;
        while (true) {
            try {
                this.audio_files.push(require(`./audio/${i}.mp3`));
            } catch (err) {
                break
            }
            i += 1
        }

        this.spots = [];
        i = 0;
        while (true) {
            try {
                this.spots.push(require(`./spots/${i + 1}.png`));
            } catch (err) {
                break
            }
            i += 1
        }

        this.video = null;

        this.state = {
            lang: this.props.lang || 'de',
            level: this.props.level || 0,
            spots: this.spots,
            max_level: 24,
            choice: null,
        };

    }

    componentDidMount() {
        this.script = document.createElement("script");
        // this.script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyCqDlLJ1pxarjD2q2Uv35B6pvJz5Nr5-Do&callback=initMap";
        this.script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyCqDlLJ1pxarjD2q2Uv35B6pvJz5Nr5-Do";
        this.script.async = true;
        document.body.appendChild(this.script);

        // this.check_interval = setInterval(this.check_code, 100)
    }

    componentWillUnmount() {
        clearInterval(this.check_interval)
    }

    take_screenshot = (video) => {
        const frame_bound = video.getBoundingClientRect();
        const canvas = document.createElement('canvas');
        canvas.width = frame_bound.width;
        canvas.height = frame_bound.height;
        canvas.style = 'position: absolute; top: 0; z-index: 10000';

        const context = canvas.getContext('2d');
        context.drawImage(video,
            0, 0,
            frame_bound.width, frame_bound.height,
        );

        // document.body.appendChild(canvas);

        let imageData = context.getImageData(0, 0, canvas.width, canvas.height);

        let code;
        try {
            code = jsQR(imageData.data, imageData.width, imageData.height, {
                inversionAttempts: "invertFirst",
            });
        } catch (e) {
            code = null;
        }

        if (code) {
            this.setState({show_qr: false})
        }
    };

    check_code = () => {
        if (this.state.show_qr) {
            this.take_screenshot(this.video)
        }
    };

    set_language = (lang) => {
        this.setState({lang: lang, level: 1})
    };

    go_back = () => {
        if (this.state.show_qr) {
            this.setState({show_qr: false})
        } else {
            this.setState({level: this.state.level - 1})
        }
    };

    center_map = () => {
        if (this.my_map) {
            this.my_map.center_card()
        }
    };

    set_choice = (num) => {
        this.setState({choice: num})
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.level !== this.state.level) {
            if (this.state.level >= 4 && this.state.level <= this.state.max_level && this.state.level % 2 === 0) {
                // this.audio.src = `${this.audio_files[(this.state.level - 4) / 2]}`
                this.audio.src = `./audio/${this.state.lang}/${(this.state.level - 4) / 2}.mp3`;
                setTimeout(() => this.audio.play(), 100)
            } else {
                this.audio.pause();
                this.audio.src = null
            }
        }

    }

    set_cam = () => {
        this.setState({show_qr: !this.state.show_qr})
    };

    set_choice_navi = () => {
        console.log(this.state.choice)
        this.setState({level: 4 + this.state.choice * 2, choice: null})
    }

    render() {
        return (
            <div className="App">
                <div className={'turn_app'} style={{backgroundImage: `url(${turn_symbol})`}}>
                    <div className={'description_turn'}>
                        Der Beethoven Rundgang ist für mobile Geräte gedacht. Bitte starten Sie ihn über Ihr Smartphone.
                    </div>
                </div>
                {
                    this.state.show_qr &&
                    <Cam camera_output={'video'}/>
                }
                <video
                    ref={obj => this.video = obj}
                    playsInline={true} muted={true} autoPlay={true}
                    style={{display: this.state.show_qr ? '' : 'none'}}
                />
                <audio ref={obj => this.audio = obj}/>
                <div className={'content'}>
                    <div className={'header'} dangerouslySetInnerHTML={{__html: '&nbsp;'}}/>
                    {
                        this.state.level === 0 &&
                        <div className={'level_0'}>
                            <Instruction action={() => this.setState({level: this.state.lang ? 1 : 0})}
                                         instruction={this.props.trans.l0[this.state.lang]}/>
                            <Language set_language={this.set_language} lang={this.state.lang}/>
                        </div>
                    }

                    {
                        this.state.level === 1 &&
                        <div className={'level_1'}>
                            <Instruction action={() => this.setState({level: this.state.lang ? 1 : 0})}
                                         instruction={this.props.trans.l1_hello[this.state.lang]}/>
                            {/*<div className={'instructions_yellow_small l1_scan'}>*/}
                            {/*    {this.props.trans.l1_qr_tip[this.state.lang]}*/}
                            {/*    <div className={'cam_symbol'}/>*/}
                            {/*</div>*/}
                            <div className={'instructions_yellow_small l1_scan'}>
                                {this.props.trans.l1_qr_audio[this.state.lang]}
                                <div className={'button_simple'} onClick={() => this.setState({level: 2})}>
                                    {this.props.trans.l1_start[this.state.lang]}
                                </div>
                            </div>
                        </div>
                    }

                    {
                        this.state.level >= 2 &&
                        <div className={`level_2 ${this.state.level >= 4 ? 'level_loop' : ''}`}>
                            {
                                this.state.level === 2 &&
                                <Instruction action={() => this.setState({level: this.state.lang ? 1 : 0})}
                                             instruction={this.props.trans.l1_hello[this.state.lang]}/>
                            }
                            {
                                (this.state.level === 200 && this.state.choice === null) &&
                                <Instruction action={() => null}
                                             instruction={this.props.trans.proceed_button[this.state.lang]}/>
                            }
                            {
                                this.state.level < 200 && this.state.level >= 4 &&
                                <>
                                    {
                                        this.state.level >= 4 &&
                                        <Instruction
                                            action={() => null}
                                            instruction={
                                                this.props.trans.l4_loop[
                                                    parseInt((this.state.level - 4) / 2, 10)
                                                    ][
                                                    ['instruction', 'next'][(this.state.level - 4) % 2]
                                                    ][this.state.lang]}
                                            level={this.state.level}
                                        />
                                    }
                                    {
                                        ((this.state.level - 4) % 2 === 0) &&
                                        <div className={'bottom_grey'} style={{zIndex: 10}}>
                                            {
                                                this.props.trans.l4_loop[
                                                    parseInt((this.state.level - 4) / 2, 10)
                                                    ].done[this.state.lang]
                                            }
                                            <div className={'button_simple'}
                                                 style={{
                                                     fontSize: `calc(var(--fs_small) * ${
                                                         this.props.trans.l4_loop[
                                                             parseInt((this.state.level - 4) / 2, 10)
                                                             ].done_button.fac
                                                     })`
                                                 }}
                                                 onClick={() => this.setState({level: this.state.level + 1})}
                                            >
                                                {
                                                    this.props.trans.l4_loop[
                                                        parseInt((this.state.level - 4) / 2, 10)
                                                        ].done_button[this.state.lang]
                                                }
                                            </div>
                                        </div>
                                    }
                                    {
                                        ((this.state.level - 4) % 2 === 1) &&
                                        <div
                                            className={'image_and_button'}
                                            style={{backgroundImage: `url(${this.images[(this.state.level - 5) / 2]})`}}
                                        >
                                            <div className={'button_simple'}
                                                 style={{
                                                     fontSize: `calc(var(--fs_small) * ${
                                                         this.props.trans.l4_loop[
                                                             parseInt((this.state.level - 4) / 2, 10)
                                                             ].done_button.fac
                                                     })`
                                                 }}
                                                 onClick={() => this.setState({level: 200})}
                                            >
                                                {
                                                    this.state.max_level - 1 === this.state.level
                                                        ? this.props.trans.end_button[this.state.lang]
                                                        : this.props.trans.proceed_button[this.state.lang]
                                                }
                                            </div>
                                        </div>
                                    }
                                </>
                            }
                            {
                                this.state.choice !== null &&
                                <div
                                    className={'instructions_yellow_small with_choice'} style={{zIndex: 10}}
                                >
                                    <div className={'image_choice_container'}>
                                        <div
                                            style={{background: `url(${this.images[this.state.choice]}) center/cover`}}
                                            className={'image_choice'}
                                        />
                                        <div
                                            className={'choice_prev icon_2'}
                                            style={{zIndex: 10}}
                                            onClick={
                                                () => this.setState({choice: (9 + this.state.choice - 1) % 9})
                                            }
                                        />
                                    </div>
                                    <div className={'text_choice_container'}>
                                        <div className={'text_choice'}>
                                            <b>{this.props.trans.l4_loop[this.state.choice].short[this.state.lang]}</b>
                                        </div>
                                        <div className={'choice_actions'}>
                                            <div className={'choice_open_navi'} onClick={() => this.set_choice_navi()}>
                                                Start
                                            </div>
                                            <div className={'choice_next icon_2'}
                                                 onClick={
                                                     () => this.setState({choice: (this.state.choice + 1) % 9})
                                                 }
                                            />
                                        </div>

                                    </div>
                                </div>
                            }
                            {
                                this.state.level === 2 &&
                                <div
                                    className={'instructions_yellow_small l2_tip'}
                                    onClick={() => this.setState({level: 200})}
                                >
                                    {this.props.trans.l2_tip[this.state.lang]}
                                    <div className={'pin_symbol'}/>
                                    <div className={'button_simple'} onClick={() => this.setState({level: 2})}>
                                        {this.props.trans.l1_weiter[this.state.lang]}
                                    </div>
                                </div>
                            }
                            {
                                (this.state.level - 4) % 2 !== 1 &&
                                <MyMap
                                    spots={this.state.spots} ref={obj => this.my_map = obj} level={this.state.level}
                                    choice={num => this.set_choice(num)} currentChoice={this.state.choice}
                                />
                            }
                        </div>
                    }
                    {
                        this.state.level === this.state.max_level &&
                        <div className={'level_end'}>
                            <Instruction
                                action={() => null}
                                instruction={this.props.trans.end_tour_instruction[this.state.lang]}
                            />
                            <div className={'end_text'}>
                                {
                                    this.props.trans.end_tour[this.state.lang]
                                }
                            </div>
                        </div>
                    }

                    {
                        this.state.level > 0 &&
                        <Footer
                            go_back={this.go_back}
                            center_map={this.center_map}
                            set_cam={this.set_cam} qr={this.state.show_qr}
                            level={this.state.level}
                        />
                    }
                </div>
            </div>
        );
    }
}

App.defaultProps = {
    level: 0,
    lang: null,
    trans: {
        proceed_button: {
            de: 'Ziel auswählen',
            en: 'Choose a destination',
            fr: 'Choisissez une destination',
        },
        end_button: {
            de: 'Tour beenden',
            en: 'End the Tour',
            fr: 'Terminer la visite',
        },
        end_tour_instruction: {
            de: 'Auf Wiedersehen',
            en: 'Goodbye',
            fr: 'Au revoir',
        },
        end_tour: {
            de: 'Wir sind nun am Ende unserer Tour angekommen. Wir hoffen, der Rundgang hat Ihnen Freude bereitet.',
            en: 'This is the end of the tour. We hope you enjoyed the tour.',
            fr: 'La visite touche à sa fin. Nous espérons que vous avez apprécié la visite.',
        },

        l0: {
            de: 'Willkommen beim Beethoven Rundgang',
            en: 'Welcome to the Beethoven Tour',
            fr: 'Bienvenue à la visite de Beethoven'
        },

        l1_hello: {
            de: 'Herzlich Willkommen',
            en: 'Welcome!',
            fr: 'Bienvenue',
        },
        l1_weiter: {
            de: 'Weiter',
            en: 'Continue',
            fr: 'Continuer',
        },
        l1_qr_tip: {
            de: 'Sie können das barrierefreie Angebot nutzen, wenn Sie den QR-Code Scannen.',
            en: 'You can use our accessibility features after scanning the QR-code.',
            fr: 'En scannant le code QR, vous pouvez utiliser l\'offre accessible aux personnes à mobilité réduite.',
        },
        l1_qr_audio: {
            de: 'Starten Sie einen Audiorundgang durch die Stadt. Sie werden zu wichtigen Orten aus dem Leben Beethovens geführt und hören interessante Geschichten.',
            en: 'Start a guided tour through the city. You will be guided to key places in Beethoven’s life while listening to interesting stories.',
            fr: 'Démarrez une visite audio-guidée de la ville. Vous découvrirez les lieux importants de la vie de Beethoven et écouterez des histoires intéressantes.',
        },
        l1_start: {
            de: 'Rundgang starten',
            en: 'Start the tour',
            fr: 'Commencer la visite',
        },

        l2_tip: {
            de: 'Wenn Sie Ihren Standort innerhalb der App sehen wollen, schalten Sie das GPS ein.',
            en: 'Turn on the GPS to see your location in the app.',
            fr: 'Si vous souhaitez voir votre emplacement dans l\'appli, activez le GPS.',
        },

        l3_walk: {
            de: 'Die Hörbilder sind ihr Wegbegleiter zwischen den historischen Stationen.',
            en: 'Soundscapes accompany you between the historical sites.',
            fr: 'Les images sonores vous accompagnent d\'une station historique à l\'autre.',
        },
        l3_walk_button: {
            de: 'Hörbild Beethoven-Haus starten',
            en: 'Start the soundscape Beethoven’s House',
            fr: 'Démarrer l\'image sonore de la Beethoven-Haus',
        },
        l3_instructtion: {
            de: 'Auf zum Beethoven-Haus',
            en: 'Walk to Beethoven’s house',
            fr: 'En chemin pour la Beethoven-Haus',
        },

        l4_loop: {
            0: {
                instruction: {
                    de: 'Sie befinden sich jetzt auf dem Weg zum Beethoven-Haus (1)',
                    en: 'You are now heading to Beethoven’s House (1)',
                    fr: 'Vous vous dirigez maintenant vers la Beethoven-Haus (1)',
                },
                short: {
                    de: 'Beethoven-Haus (1)',
                    en: 'Beethoven’s House (1)',
                    fr: 'Beethoven-Haus (1)',
                },
                done: {
                    de: '',
                    en: '',
                    fr: '',
                },
                done_button: {
                    de: 'Am Beethoven-Haus angekommen',
                    en: 'You have arrived at Beethoven’s House',
                    fr: 'Arrivé à la Beethoven-Haus',
                    fac: .95,
                },
                next: {
                    de: 'Sehen Sie sich das Beethoven-Haus an.',
                    en: 'You can visit Beethoven’s House.',
                    fr: 'Visitez la Beethoven-Haus.',
                }
            },
            1: {
                instruction: {
                    de: 'Sie befinden sich jetzt auf dem Weg zur Remigiuskirche (2)',
                    en: 'You are now heading to St. Remigius (2)',
                    fr: 'Vous vous dirigez maintenant vers l\'église Saint-Remi (2)',
                },
                short: {
                    de: 'Remigiuskirche (2)',
                    en: 'St. Remigius (2)',
                    fr: 'L\'église Saint-Remi (2)',
                },
                done: {
                    de: '',
                    en: '',
                    fr: '',
                },
                done_button: {
                    de: 'An Remigiuskirche angekommen',
                    en: 'You have arrived at St. Remigius',
                    fr: 'Arrivé à l\'église Saint-Remi',
                    fac: 1,
                },
                next: {
                    de: 'Sehen Sie sich die Remigiuskirche an.',
                    en: 'You can visit St. Remigius.',
                    fr: 'Visitez l\'église Saint-Remi.',
                }
            },
            2: {
                instruction: {
                    de: 'Sie befinden sich jetzt auf dem Weg zum "Wirtshaus Zehrgarten" (3)',
                    en: 'You are now heading to the tavern "Zehrgarten" (3)',
                    fr: 'Vous vous dirigez maintenant vers l\' "auberge du Zehrgarten" (3)',
                },
                done: {
                    de: '',
                    en: '',
                    fr: '',
                },
                short: {
                    de: '"Wirtshaus Zehrgarten" (3)',
                    en: 'Tavern "Zehrgarten" (3)',
                    fr: 'L\' "auberge du Zehrgarten" (3)',
                },
                done_button: {
                    de: 'Am "Wirtshaus Zehrgarten" angekommen',
                    en: 'You have arrived at the tavern "Zehrgarten"',
                    fr: 'Arrivé à l\' "auberge du Zehrgarten"',
                    fac: 1,
                },
                next: {
                    de: 'Sehen Sie sich das "Wirtshaus Zehrgarten" an.',
                    en: 'You can visit the tavern "Zehrgarten".',
                    fr: 'Visitez l\' "auberge du Zehrgarten".',
                }
            },
            3: {
                instruction: {
                    de: 'Sie befinden sich jetzt auf dem Weg zum Remigiusplatz (4)',
                    en: 'You are now on heading to Remigiusplatz (4)',
                    fr: 'Vous vous dirigez maintenant vers la place Saint-Remi (4)',
                },
                short: {
                    de: 'Remigiusplatz (4)',
                    en: 'Remigiusplatz (4)',
                    fr: 'La place Saint-Remi (4)',
                },
                done: {
                    de: '',
                    en: '',
                    fr: '',
                },
                done_button: {
                    de: 'Am Remigiusplatz angekommen',
                    en: 'You have arrived at Remigiusplatz',
                    fr: 'Arrivé à la place Saint-Remi',
                    fac: 1,
                },
                next: {
                    de: 'Sehen Sie sich den Remigiusplatz an.',
                    en: 'You can visit Remigiusplatz.',
                    fr: 'Visitez la place Saint-Remi.',
                }
            },
            4: {
                instruction: {
                    de: 'Sie befinden sich jetzt auf dem Weg zur Kurfürstlichen Schlosskapelle (5)',
                    en: 'You are now heading to the Electoral Castle Chapel (5)',
                    fr: 'Vous vous dirigez maintenant vers la chapelle de la cour électorale (5)',
                },
                short: {
                    de: 'Schlosskapelle (5)',
                    en: 'Electoral Castle Chapel (5)',
                    fr: 'La cour électorale (5)',
                },
                done: {
                    de: '',
                    en: '',
                    fr: '',
                },
                done_button: {
                    de: 'An Kurfürstlicher Schlosskapelle angekommen',
                    en: 'You have arrived at the Electoral Castle Chapel',
                    fr: 'Arrivé à la chapelle de la cour électorale',
                    fac: 1,
                },
                next: {
                    de: 'Sehen Sie sich die Kurfürstliche Schlosskapelle an.',
                    en: 'You can visit the Electoral Castle Chapel.',
                    fr: 'Visitez la chapelle de la cour électorale.',
                }
            },
            5: {
                instruction: {
                    de: 'Sie befinden sich jetzt auf dem Weg zum Rheinufer (6)',
                    en: 'You are now on heading to the banks of the Rhine (6)',
                    fr: 'Vous vous dirigez maintenant vers la rive du Rhin (6)',
                },
                short: {
                    de: 'Rheinufer (6)',
                    en: 'Banks of the Rhine (6)',
                    fr: 'La rive du Rhin (6)',
                },
                done: {
                    de: '',
                    en: '',
                    fr: '',
                },
                done_button: {
                    de: 'Am Rheinufer angekommen',
                    en: 'You have arrived at the banks of the Rhine',
                    fr: 'Arrivé sur la rive du Rhin',
                    fac: 1,
                },
                next: {
                    de: 'Sehen Sie sich das Rheinufer an.',
                    en: 'Take a look around the banks of the Rhine.',
                    fr: 'Parcourez la rive du Rhin.',
                }
            },
            6: {
                instruction: {
                    de: 'Sie befinden sich jetzt auf dem Weg zum Breunigschen Haus (7)',
                    en: 'You are now heading to Breunig’s House (7)',
                    fr: 'Vous vous dirigez maintenant vers la maison Breuning (7)',
                },
                short: {
                    de: 'Breunigschen Haus (7)',
                    en: 'Breunig’s House (7)',
                    fr: 'La maison Breuning (7)',
                },
                done: {
                    de: '',
                    en: '',
                    fr: '',
                },
                done_button: {
                    de: 'Am Breunigschen Haus angekommen',
                    en: 'You have arrived at Breunig\'s house',
                    fr: 'Arrivé à la maison Breuning',
                    fac: 1,
                },
                next: {
                    de: 'Das Breunigsche Haus gibt es nicht mehr, setzen Sie die Tour zum Beethoven Denkmal fort. (8)',
                    de_alt: 'Sehen Sie sich das Breunigsche Haus an oder setzen Sie die Tour zum Beethoven Denkmal (8) fort.',
                    en: 'You can\'t visit Breunig’s House anymore. Continue the tour to the Beethoven monument. (8)',
                    fr: 'Visitez la maison Breuning ou continuez votre chemin vers le monument de Beethoven. (8)',
                }
            },
            7: {
                instruction: {
                    de: 'Sie befinden sich jetzt auf dem Weg zum Beethoven Denkmal (8)',
                    en: 'You are now heading to the Beethoven monument (8)',
                    fr: 'Vous vous dirigez maintenant vers le monument de Beethoven (8)',
                },
                short: {
                    de: 'Beethoven Denkmal (8)',
                    en: 'Beethoven monument (8)',
                    fr: 'Le monument de Beethoven (8)',
                },
                done: {
                    de: '',
                    en: '',
                    fr: '',
                },
                done_button: {
                    de: 'Am Beethoven Denkmal angekommen',
                    en: 'You have arrived at the Beethoven monument',
                    fr: 'Arrivé au monument de Beethoven',
                    fac: 1,
                },
                next: {
                    de: 'Sehen Sie sich das Beethoven Denkmal an.',
                    en: 'Take a look at the Beethoven monument.',
                    fr: 'Visitez le monument de Beethoven.',
                }
            },
            8: {
                instruction: {
                    de: 'Sie befinden sich jetzt auf dem Weg zum Alten Friedhof (9)',
                    en: 'You are now heading to the Alter Friedhof (9)',
                    fr: 'Vous vous dirigez maintenant vers l\'ancien cimetière (9)',
                },
                short: {
                    de: 'Alten Friedhof (9)',
                    en: 'Alter Friedhof (9)',
                    fr: 'L\'ancien cimetière (9)',
                },
                done: {
                    de: '',
                    en: '',
                    fr: '',
                },
                done_button: {
                    de: 'Am Alten Friedhof angekommen',
                    en: 'You have arrived at the Alter Friedhof',
                    fr: 'Arrivé à l\'ancien cimetière',
                    fac: 1,
                },
                next: {
                    de: 'Sehen Sie sich den Alten Friedhof an.',
                    en: 'You can visit the Alter Friedhof.',
                    fr: 'Visitez l\'ancien cimetière.',
                }
            },
            9: {
                instruction: {
                    de: 'Sie befinden sich jetzt auf dem Weg zur Rheingasse (10)',
                    en: '',
                    fr: '',
                },
                done: {
                    de: '',
                    en: '',
                    fr: '',
                },
                done_button: {
                    de: 'An Rheingasse angekommen',
                    en: '',
                    fr: '',
                    fac: 1,
                },
                next: {
                    de: 'Sehen Sie sich die Rheingasse an. Dies ist auch gleichzeitig die letzte Station.',
                    en: '',
                    fr: '',
                }
            },
        }
    }
};

export default App;
